<template>
  <div class="login-page">
    <div class="login-content">
      <h1 class="login-title">
        {{ $config("LOGIN_TITLE_N") }}
      </h1>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form
          class="login-form"
          @submit.prevent="handleSubmit(login)"
          novalidate
        >
          <form-input
            class="login-input"
            name="email"
            type="email"
            v-model="email"
            :placeholder="$config('EMAIL_N')"
            required
          />

          <form-input
            class="login-input"
            name="password"
            type="password"
            v-model="password"
            :placeholder="$config('PASSWORD_N')"
            required
          />

          <router-link
            :to="{ name: 'forgot-password' }"
            class="forgot-link"
          >
            {{ $config("LOST_PASSWORD_N") }}
          </router-link>

          <btn class="login-btn">
            {{ $config("LOGIN_N") }}
          </btn>
        </form>
      </ValidationObserver>

      <div class="login-footer">
        <span>{{ $config("NO_REGISTER_N") }}</span>
        <router-link
          :to="{ name: 'register-sign-up' }"
          class="register-link"
        >
          {{ $config("SIGN_HERE_N") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import allowGuestsOnly from "../mixins/allowGuestsOnly";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";

import FormInput from "../components/FormInput";
import Btn from "../components/Btn";

export default {
  name: "login",

  components: {
    FormInput,
    Btn
  },

  mixins: [allowGuestsOnly, requestWithInteractions],

  data() {
    return {
      email: "",
      password: ""
    };
  },

  computed: {
    ...mapGetters(["registerOrHomeRoute"])
  },

  methods: {
    async login() {
      this.sendRequest(api.login(this.email, this.password), {
        beforeSendText: this.$config("LOGIN"),
        successText: this.$config("BIENVENIDO"),
        failureCondition: r => !r.success,
        onSuccess: r => {
          this.$store.commit("SET_AUTHENTICATED_USER", r.userdata);
          this.$store.commit(
            "SET_AUTHENTICATED_USER_ACCESS",
            r.access
          );
          this.$router.push(this.registerOrHomeRoute);
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* ===== PAGE BACKGROUND ===== */
.login-page {
  background: url("~@/assets/img/new/pinguinitos-bg.jpg") no-repeat center;
  background-size: cover;
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-page::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 35, 70, 0.65);
  z-index: 1;
}

/* Bring content above overlay */
.login-page > * {
  position: relative;
  z-index: 2;
}

/* ===== CONTENT WRAPPER ===== */
.login-content {
  width: 100%;
  max-width: 500px;
  text-align: center;
  padding: 0 24px;
}

/* ===== TITLE ===== */
.login-title {
  color: #ffffff;
  margin-bottom: 64px;
  font-size: 60px;
  line-height: 84px;
  font-weight: 600 !important;
  font-family: "Encode Sans Semi Expanded", sans-serif !important;
}

/* ===== FORM ===== */
.login-form {
  display: flex;
  flex-direction: column;
  max-width: 460px;
  height: 320px;
}

/* ===== INPUT OVERRIDES (NO DEEP, NO SCOPED) ===== */
.login-input input {
  background-color: rgba(15, 89, 153, 0.9) !important;
  border-radius: 38px;
  border-style: solid;
  border-color: #1e6790;
  border-width: 2px;
  height: 48px;
  font-size: 16px;
  padding: 10px 1rem;
  width: 100%;
  color: #ffffff;
  font-family: "Encode Sans Semi Expanded", sans-serif !important;
  color: rgba(255, 255, 255, 0.9);
  text-align: left;
  line-height: 20px;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: end;
}

.login-input input::placeholder {
  color: rgba(255, 255, 255, 0.85);
}

/* Kill legacy FormInput decorations */
.login-input .form-input__underline,
.login-input .form-input__border,
.login-input .form-input__icon,
.login-input .form-input__append {
  display: none !important;
}

.login-input input:focus {
  outline: none;
  box-shadow: none;
}

/* ===== LINKS ===== */
.forgot-link {
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  font-family: "Encode Sans Semi Expanded", sans-serif !important;
  position: relative;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== BUTTON ===== */
.login-btn, .login-btn:hover {
  background: #f58a38;
  color: #ffffff;
  border-radius: 38px;
  padding: 16px 33px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  height: 48px;
  position: relative;
  overflow: hidden;
  font-family: "Encode Sans Semi Expanded", sans-serif !important;
  margin-top: auto;
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
}

/* ===== FOOTER ===== */
.login-footer {
  text-align: center;
  font-family: "Encode Sans Semi Expanded", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  position: relative;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}

.login-footer .register-link {
  color: #7de3ff;
  font-weight: 600;
  margin-left: 4px;
}

@media (max-width: 768px) {
  .login-title {
    color: #ffffff;
    font-size: 40px;
    line-height: 75.6px;
    font-weight: 700;
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .login-input input {
    font-size: 18px;
    line-height: 20px;
  }

  .login-btn, .login-btn:hover {
    font-size: 20px;
    line-height: 20px;
    font-weight: 600;
    height: 48px;
  }

  .login-footer {
    text-align: left;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
  }

  .forgot-link {
    color: #ffffff;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
  }
}
</style>